import { render, staticRenderFns } from "./MessengerChannels.vue?vue&type=template&id=3cba4dce&scoped=true"
import script from "./MessengerChannels.vue?vue&type=script&lang=js"
export * from "./MessengerChannels.vue?vue&type=script&lang=js"
import style0 from "./MessengerChannels.vue?vue&type=style&index=0&id=3cba4dce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cba4dce",
  null
  
)

export default component.exports